import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { AuthGuard } from './auth/guards/authorize.guard';

export const ROUTES: Route[] = [
  {
    path: '',
    redirectTo: '/profile',
    pathMatch: 'full',
  },
  {
    path: 'profile',
    loadChildren: () =>
      import(
        './features/company-profile-data/company-profile-data.module'
      ).then((m) => m.CompanyProfileDataModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'staff',
    loadChildren: () =>
      import('./features/staff/staff.module').then((m) => m.StaffModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'sick-leave',
    loadChildren: () =>
      import('./features/sick-leave/sick-leave.module').then(
        (m) => m.SickLeaveModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'medical-examine',
    loadChildren: () =>
      import('./features/medical-examine/medical-examine.module').then(
        (m) => m.MedicalExamineModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'new-worker',
    loadChildren: () =>
      import('./features/new-worker/new-worker.module').then(
        (m) => m.NewWorkerModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'queries',
    loadChildren: () =>
      import('./features/queries/queries.module').then((m) => m.QueriesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'sentmails',
    loadChildren: () =>
      import('./features/sentmails/sent-mails.module').then((m) => m.SentMailsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'companies',
    loadChildren: () =>
      import('./features/companies/companies.module').then((m) => m.CompaniesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'documents',
    loadChildren: () =>
      import('./features/documents/documents.module').then(
        (m) => m.DocumentsModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'characteristic',
    loadChildren: () =>
      import('./features/characteristic/characteristic.module').then(
        (m) => m.CharacteristicModule
      ),
  },
  {
    path: 'telk-decision',
    loadChildren: () =>
      import('./features/telk-desicion/telk-decision.module').then(
        (m) => m.TelkDecisionModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'mail',
    loadChildren: () =>
      import(
        './features/mail/mail.module'
      ).then((m) => m.MailModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'mail-campaign',
    loadChildren: () =>
      import(
        './features/mail-campaign/mail-campaign.module'
      ).then((m) => m.MailCampaignModule),
    canActivate: [AuthGuard]
  },
  //TODO Create 404 landing page for uknown routes
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(ROUTES)],
  exports: [RouterModule],
})
export class AppRouterModule {}
